import { API } from "./axiosInstance"

/**
 * Gets all the functionalities
 * @returns the functionalities
 */
export const getFunctionalities = async () => {
    const functionalities = await API.get(`/functionalities?isDeleted=0`);
    return functionalities.data;
}

/**
 * Gets all the functionalities connected to this application
 * @returns the functionalities
 */
export const getFunctionalitiesFromApplicationId = async (applicationId) => {
    const functionalities = await API.get(`/functionalities?applicationId=${applicationId}&isDeleted=0`);
    return functionalities.data;
}

/**
 * Calls the post functionalities endpoint
 * @param {*} functionality the functionality to create
 * @returns the response from usermanagement-service
 */
export const createFunctionality = async (functionality) => {
    const createdFunctionality= await API.post('/functionalities', functionality);
    return createdFunctionality;
}

/**
 * Accepts a requested change for an functionalities
 * @param {*} staticId the id of the functionalities in the static model
 * @returns the accepted functionalities
 */
export const acceptChange = async(staticId) => {
    const response = await API.post(`/functionalities/${staticId}/accept`);
    return response.data;
}

/**
 * Rejects a requested change for an functionalities
 * @param {*} staticId the id of the functionalities in the static model
 * @returns the rejected functionalities
 */
export const rejectChange = async(staticId) => {
    const response = await API.post(`/functionalities/${staticId}/reject`);
    return response.data;
}
/**
 * Calls the put functionalities endpoint
 * @param {*} functionality the functionality to update
 * @returns the response from usermanagement-service
 */
export const updateFunctionality = async (staticId, functionality) => {
    const updatedFunctionality= await API.put(`/functionalities/${staticId}/`, functionality);
    return updatedFunctionality;
}
